/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const AccountRole = {
    generalUser: 'GENERAL_USER',
    organizationAdmin: 'ORGANIZATION_ADMIN',
    viewer: 'VIEWER',
    bookkeeper: 'BOOKKEEPER'
} as const;

export type AccountRole = typeof AccountRole[keyof typeof AccountRole];



